<template>
  <div>
    <div>หมายเลขคำสั่งซื้อ: {{ invoiceNo }}</div>
    <div>ราคารวม: {{ orderTotalAmount | numeral("0,0.00") }}</div>
    <div class="mt-2">
      <b-form-group label="ธนาคารปลายทาง" v-slot="{ ariaDescribedby }">
        <b-form-radio
          v-for="bank in bankAccountList"
          :key="bank.bankId"
          v-model="paymentSelected.bankAccountId"
          :aria-describedby="ariaDescribedby"
          :name="'bank-' + bank.bankName"
          :value="bank.id"
          :disabled="!isCanEdit"
        >
          <div>
            <img :src="bank.imageUrl" :alt="bank.imageUrl" class="bank-image" />
            <span class="ml-2">{{ bank.bankName }}</span>
          </div>
        </b-form-radio>
      </b-form-group>
    </div>
    <div>
      <InputText
        textFloat="จำนวนเงิน"
        v-model="paymentSelected.amount"
        class="mr-2"
        placeholder="จำนวนเงิน"
        type="number"
        :isValidate="v.amount.$error"
        isRequired
        :v="v.amount"
        :isDisplay="!isCanEdit"
      />
    </div>
    <div class="picker-container">
      <div class="mt-3">
        <label class="mb-1 font-weight-bold">วันที่โอน</label>
        <div class="input-container mr-2">
          <datetime
            :input-style="styleDatetime"
            v-model="paymentSelected.transferDate"
            placeholder="วว / ดด / ปป"
            ref="transferDate"
            value-zone="Asia/Bangkok"
            :disabled="!isCanEdit"
          >
          </datetime>
          <div
            class="icon-container text-right"
            @click="$refs.transferDate.isOpen = true"
          >
            <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
          </div>
        </div>
      </div>
      <div class="mt-3">
        <label class="mb-1 font-weight-bold">เวลาที่โอน</label>
        <div class="input-container mr-2">
          <datetime
            :input-style="styleDatetime"
            v-model="paymentSelected.transferTime"
            type="time"
            placeholder="ชม. / นาที"
            value-zone="Asia/Bangkok"
            ref="transferTime"
            :disabled="!isCanEdit"
          >
          </datetime>
          <div
            class="icon-container text-right"
            @click="$refs.transferTime.isOpen = true"
          >
            <b-icon
              icon="clock-fill"
              class="float-right"
              color="#B41BB4"
            ></b-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-3 mr-2">
      <UploadFile
        textFloat="อัพโหลดภาพ"
        placeholder="กรุณาเลือกไฟล์เพื่ออัพโหลด"
        format="image"
        name="thumbnail"
        :fileName="paymentSelected.imageUrl"
        text=""
        isRequired
        v-on:onFileChange="onImageChange"
        v-on:delete="onDeleteImage"
        :v="v.imageUrl"
        :disabled="!isCanEdit"
      />
    </div>
    <div class="mt-2">
      <InputTextArea
        class=""
        type="text"
        textFloat="บันทึกเพิ่มเติม"
        placeholder="บันทึกเพิ่มเติม"
        name="text"
        rows="5"
        isRequired
        v-model="paymentSelected.note"
        :disabled="!isCanEdit"
      />
    </div>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import UploadFile from "@/components/inputs/UploadFile";
import InputTextArea from "@/components/inputs/InputTextArea";
export default {
  components: {
    InputText,
    UploadFile,
    InputTextArea,
  },
  props: {
    invoiceNo: {
      required: true,
      type: String,
    },
    orderTotalAmount: {
      required: true,
      type: Number,
    },
    paymentSelected: {
      required: true,
      type: Object,
    },
    bankAccountList: {
      required: true,
      type: Array,
    },
    v: {
      required: true,
      type: Object,
    },
    isCanEdit: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      styleDatetime: {
        width: "100%",
        border: "none",
      },
      note: "",
    };
  },
  methods: {
    onImageChange(img, index) {
      var reader = new FileReader();
      const objectURL = URL.createObjectURL(img);
      reader.readAsDataURL(img);

      reader.onload = async () => {
        this.paymentSelected.imageUrl = objectURL;
      };
    },

    onDeleteImage() {},
  },
};
</script>

<style scoped>
.bank-image {
  width: 30px;
  height: 30px;
}
.input-container {
  display: flex;
  padding: 0.5rem;
  border: 1px solid #bcbcbc;
  border-radius: 6px;
  align-items: center;
  justify-content: space-between;
}
</style>